import { Col, Row } from 'antd';
import React from 'react';
import HeaderCard from '../../components/HeaderCard';
import './style.scss';
import RedashDashboard from '../../components/RedashDashboard';

// constants
const redashDashboards = [
  {
    title: 'Agronomist Participating Ha Performance:',
    dashboardUrl: process.env['REACT_APP_REDASH_URL_AGRONOMIST_HA_PERFORMANCE'],
  },
  {
    title: 'Agronomist AWD Compliance Detail:',
    dashboardUrl: process.env['REACT_APP_REDASH_URL_AGRONOMIST_AWD_COMPLIENCE'],
  },
];
export default function Performance() {
  return (
    <div className="performance-wrapper">
      <HeaderCard
        headerLabel="Agronomist Performance"
        headerInfo="Agronomist performance overview appears here"
      />

      <Row>
        <Col span={24} className="performance-container">
          {redashDashboards.map((dashboard, index) => (
            <RedashDashboard
              key={index}
              className={'redash-container'}
              title={dashboard.title}
              dashboardUrl={dashboard.dashboardUrl}
              height={620}
              width={'100%'}
            />
          ))}
        </Col>
      </Row>
    </div>
  );
}
